import { connect } from 'react-redux'
import * as apiClientActions from '../../common/ApiClient/ApiClientActions'
import * as appActions from './AppActions'
import * as flashMessageActions from '../FlashMessage/FlashMessageActions'
import App from './App'

const mapStateToProps = (state) => ({
    apiClientLoaded: state.apiClient.loaded,
    path: state.app.path
})

const actions = {
    ...apiClientActions,
    ...appActions,
    ...flashMessageActions
}

export default connect(mapStateToProps, actions)(App)


// WEBPACK FOOTER //
// ./src/components/App/index.jsx